import React from "react";
import styled from "styled-components";
import { Info } from "@material-ui/icons";
import Tooltip from '@material-ui/core/Tooltip';
import TooltipComponent from "../gComponents/gTooltip";
const H4 = styled.h4`
  color: #000;
  font-size: 15px;
  margin: 2px 0;
  font-weight: 500;
  &.inline {
    font-family: LatoWeb;
    color: #333;
  }
`;
const P = styled.p`
  color: #333;
  font-size: 14px;
  margin: 2px 0px;
  line-height: 19px;

  &.inline {
    color: #555;
  }
`;

const Table = styled.table`
  width: 100%;

  tr.line {
    td {
      padding: 0px;
      border-top: 1px solid #e2e2e2;
    }
  }

  td {
    padding: 6px 5px;
  }
`;

export const GContent = (props) => {
  return (
    <div style={{ padding: "5px 0", textTransform: props.textTransform }}>
      <H4>
        {props.title} &nbsp;
        {props.tooltip === true ? (
          <TooltipComponent
            title={props.tContent}
            position="bottom"
            id={props.title}
          >
            <Info fontSize="small" />
          </TooltipComponent>
        ) : (
          ""
        )}
      </H4>
      <P> {props.value}</P>
    </div>
  );
};

export const GInlineContent = (props) => {
  return (
    <div
      style={{
        padding: "5px 0",
        display: "flex",
        textTransform: props.textTransform,
      }}
    >
      <H4 className="inline">{props.title}</H4>
      &nbsp; : &nbsp;&nbsp;
      <P className="inline" style={{ whiteSpace: "pre-line" }}>
        {" "}
        {props.value}
      </P>
    </div>
  );
};

export const GTableContent = (props) => {
  return (
    <Table>
      <tbody>
        <tr className={props.title}>
          <td
            style={{
              textAlign: props.lAlign ? "left" : "left",
              padding: props.padding,
            }}
          >
            {props.title === "line" ? (
              ""
            ) : (
              <P
                style={{
                  color: props.color,
                  fontSize: props.fontSize,
                  fontFamily: props.bold === true ? "LatoWebBold" : "LatoWeb",
                  display:"inline-flex",
                  alignItems:"center"
                }}
              >
                {props.title} &nbsp;
                {props.title==="Taxes & Fees"?<Tooltip title={props.detail?.map((e)=><small>{e.title}&nbsp; ${e.value}<br/></small>)}>
                   <Info />
                 </Tooltip>:""}  
              </P>
            )}
          </td>
          <td
            style={{
              textAlign: props.align ? props.align : "left",
              padding: props.padding,
              width: "50%",
            }}
          >
            {props.title === "line" ? (
              ""
            ) : (
              <P
                style={{
                  color: props.color,
                  fontSize: props.fontSize,
                  fontFamily: props.bold === true ? "LatoWebBold" : "LatoWeb",
                }}
              >
                {props.value}
                {props.innerValue ? <span>({props.innerValue})</span> : ""}
              </P>
            )}
          </td>
        </tr>
      </tbody>
    </Table>
  );
};
